// Nihir -- TODO:
// We likely don't want this hard coded on the front-end
// Because it is a duplication of an object on the backend
// I think the Ideal situation is to move these ranges to the database and use them in FE and BE
// But until a decision is made, sticking it here.
const PRICE_RANGES = {
  tops: [
    { label: "$", min: 0, max: 30 },
    { label: "$$", min: 30, max: 60 },
    { label: "$$$", min: 60, max: 120 },
    { label: "$$$$", min: 120, max: 999999 },
  ],
  bottoms: [
    { label: "$", min: 0, max: 35 },
    { label: "$$", min: 35, max: 80 },
    { label: "$$$", min: 80, max: 160 },
    { label: "$$$$", min: 160, max: 999999 },
  ],
  outerwear: [
    { label: "$", min: 0, max: 50 },
    { label: "$$", min: 50, max: 100 },
    { label: "$$$", min: 100, max: 200 },
    { label: "$$$$", min: 200, max: 999999 },
  ],
  footwear: [
    { label: "$", min: 0, max: 45 },
    { label: "$$", min: 45, max: 100 },
    { label: "$$$", min: 100, max: 200 },
    { label: "$$$$", min: 200, max: 999999 },
  ],
  underwear: [
    { label: "$", min: 0, max: 20 },
    { label: "$$", min: 20, max: 40 },
    { label: "$$$", min: 40, max: 80 },
    { label: "$$$$", min: 80, max: 999999 },
  ],
  swimwear: [
    { label: "$", min: 0, max: 25 },
    { label: "$$", min: 25, max: 50 },
    { label: "$$$", min: 50, max: 100 },
    { label: "$$$$", min: 100, max: 999999 },
  ],
  sleepwear: [
    { label: "$", min: 0, max: 30 },
    { label: "$$", min: 30, max: 70 },
    { label: "$$$", min: 70, max: 130 },
    { label: "$$$$", min: 130, max: 999999 },
  ],
  accessories: [
    { label: "$", min: 0, max: 25 },
    { label: "$$", min: 25, max: 75 },
    { label: "$$$", min: 75, max: 200 },
    { label: "$$$$", min: 200, max: 999999 },
  ],
  activewear: [
    { label: "$", min: 0, max: 40 },
    { label: "$$", min: 40, max: 80 },
    { label: "$$$", min: 80, max: 150 },
    { label: "$$$$", min: 150, max: 999999 },
  ],
};

export type PriceCategoryKey = keyof typeof PRICE_RANGES;

export function getPriceRange(cat: PriceCategoryKey, range?: string) {
  return PRICE_RANGES[cat].find((r) => r.label === range);
}
